module.exports = __webpack_public_path__ + "9a59543e2a35569e586f4ff9bfeb3dab.fbx";